<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-notebook-2"></i> 门店管理 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!-- <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                    v-if="perData.allow_dele == 1"
                    >批量删除</el-button
                > -->
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select> -->
                <el-input v-model="name" placeholder="门店编号、门店名称、关联门店" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float: right" type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1" @click="handleAdd"
                    >{{ $t('common.add') }}</el-button
                >
            </div>
            <el-table
                :data="tableData"
                stripe
                border
                height="600"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
                default-expand-all
                row-key="id"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                :fit="true"
            >
                <el-table-column type="selection" width="80"></el-table-column>
                <el-table-column label="序号" width="150" sortable>
                    <template slot-scope="scoped">
                        {{ scoped.$index + 1 }}
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="250" v-if="perData.allow_edit == 1 || perData.allow_dele == 1">
                    <template slot-scope="scope">
                        <el-button
                            type="primary"
                            plain
                            icon="el-icon-edit"
                            @click="handleEdit(scope)"
                            v-if="perData.allow_edit == 1 && scope.row.id != 1"
                            >{{ $t('common.edit') }}</el-button
                        >
                        <el-button
                            type="danger"
                            plain
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope)"
                            v-if="perData.allow_dele == 1 && scope.row.id != 1"
                            >{{ $t('common.delete') }}</el-button
                        >
                    </template>
                </el-table-column>

                <el-table-column prop="store_no" label="门店编号" sortable width="120"></el-table-column>
                <el-table-column prop="store_name" label="门店名称" sortable width="120"> </el-table-column>

                <el-table-column prop="status" label="状态" width="120">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success">启用<i class="el-icon-check"></i></el-tag>
                        <el-tag v-if="scope.row.status == 0" type="danger">停用<i class="el-icon-close"></i></el-tag>
                        <el-tag v-if="scope.row.status == -1" type="warning">锁定<i class="el-icon-lock"></i></el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="remark" :label="$t('common.remark')" width="300" :show-overflow-tooltip="true"></el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :current-page="pageIndex"
                    :page-sizes="[pageTotal]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <el-drawer :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
            <div class="form_warpper">
                <el-form :model="addData" ref="addform" label-width="100px" label-position="left" :rules="rules">
                    <el-form-item label="上级门店" prop="pid">
                        <el-select v-model="addData.pid" filterable placeholder="请选择" style="width: 100%">
                            <el-option v-for="item in pullData.p_store" :key="item.pid" :label="item.store_name" :value="item.pid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="门店编号" prop="store_no">
                        <label slot="label">门店编号</label>
                        <el-input v-model="addData.store_no" :disabled="!isAdd"></el-input>
                        <!-- <el-select
                            :disabled="!isAdd"
                            v-model="addData.store_no"
                            placeholder="请选择门店"
                            @change="selectChange"
                            style="width: 100%"
                        >
                            <el-option v-for="item in pullData.store" :label="item.kind_name" :key="item.kind_no" :value="item.kind_no">
                                <span>{{ item.kind_no }}</span>
                                <span>{{ item.kind_name }}</span>
                            </el-option>
                        </el-select> -->
                        <!-- <mySelect
                            v-model="addData.data.store_no"
                            style="width: 100%"
                            :options="pullData.store"
                            values="kind_no"
                            labels="kind_name"
                            keys="kind_no"
                        ></mySelect> -->
                    </el-form-item>
                    <el-form-item label="门店名称" prop="store_name">
                        <el-input v-model="addData.store_name"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-radio-group v-model="addData.status" @change="changeradio">
                            <el-radio :label="1">启用</el-radio>
                            <!-- <el-radio :label="-1">锁定</el-radio> -->
                            <el-radio :label="0">停用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('common.remark')">
                        <el-input type="textarea" v-model="addData.remark" :rows="3"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button type="primary" @click="saveAdd">确 定</el-button>
                    <el-button @click="drawer = false">取 消</el-button>
                </div>
            </div>
        </el-drawer>
        <!-- 编辑弹出框 -->
    </div>
</template>

<script>
import { fetchData } from '../../api/index';
import {
    apisetList,
    apisetDetail,
    apiaddSet,
    apimodifySet,
    apidelSet,
    apiCurrentPermisson,
    storeIndex,
    pullStore,
    storeAdd,
    storeDel,
    storeUp
} from '@/request/api';
import Icon from './Icon.vue';
import { thistle } from 'color-name';
export default {
    components: { Icon },
    name: 'basetable',
    data() {
        return {
            name: '',
            perData: '',
            pageIndex: 1,
            pageSize: 1000,
            tableData: [],
            pageTotal: 0,
            selectList: [],
            drawer: false,
            addData: {
                status: 1
            },
            pullData: {},
            isAdd: true,
            rules: {
                store_no: [
                    {
                        required: true,
                        message: '请输入门店编号',
                        trigger: 'blur,change'
                    }
                ],
                store_name: [
                    {
                        required: true,
                        message: '请输入门店名称',
                        trigger: 'blur'
                    }
                ],
                pid: [{ required: true, message: '请选择上级门店', trigger: 'change' }],
                // counter_no: [
                //     {
                //         required: true,
                //         message: '至少选择一个门店',
                //         trigger: 'blur'
                //     }
                // ],
                status: [{ required: true }]
            }
        };
    },
    created() {
        this.getData();
        this.getPull();
        this.getPermission();
    },
    // activated() {
    //     this.getData();
    //     this.getPermission();
    // },
    methods: {
        // selectChange(val) {
        //     this.addData.store_no = Number(val);
        //     let index = this.pullData.store.findIndex((item) => item.kind_no == val);
        //     this.addData.store_name = this.pullData.store[index].kind_name;
        //     this.$forceUpdate();
        // },
        // 获取列表信息
        getData() {
            this.$load.show();
            storeIndex({
                page: this.pageIndex,
                page_size: this.pageSize,
                seek: this.name
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.count;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getPull() {
            pullStore({}).then((res) => {
                this.pullData = res.data;
            });
        },
        changeradio(val) {},
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '9'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.drawer = true;
            this.addData = { status: 1 };
            this.isAdd = true;
            this.getPull();
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        handleEdit(scope) {
            this.drawer = true;
            this.addData = scope.row;
            this.addData.status = Number(scope.row.status);
            this.isAdd = false;
            this.getPull();
        },
        handleClose() {
            this.drawer = false;
        },
        saveAdd() {
            this.$refs.addform.validate((valid) => {
                if (valid) {
                    let data = this.addData;
                    if (this.isAdd) {
                        storeAdd(data).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '添加成功', type: 'success' });
                                this.drawer = false;
                                this.getData();
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    } else {
                        storeUp(data).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '修改成功', type: 'success' });
                                this.drawer = false;
                                this.getData();
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    }
                } else {
                    return;
                }
            });
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(scope) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    storeDel({
                        id: scope.row.id
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作----------------------------------------------------------------------------------------------------
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function (item, index, array) {
                arr.push(item.type_no);
            });
            this.selectList = arr;
        },
        delAllSelection() {
            if (this.selectList.length <= 0) {
                this.$message({ message: '请先选择需要操作的对象', type: 'error' });
                return;
            }
            this.$confirm('此操作将批量删除, 是否继续?', '批量删除提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            })
                .then(() => {
                    apidelSet({
                        type_no: this.selectList.join(',')
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                    // this.$message({ type: 'info',  message: '已取消删除' });
                });
        },

        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped lang="scss">
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.form_warpper {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;
    .dialog-footer {
        width: 100%;
        border-top: 1px solid #e7e7e7;
        position: absolute;
        bottom: 0;
        padding: 20px 0;
    }
}
/deep/.el-table .cell {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
<!-- <style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.el-table .cell {
    white-space: nowrap;
}
.el-dialog {
    width: 40%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style> -->